import { Injectable, NgZone } from '@angular/core';
import { Globals } from '../models/globals.model';
import { SseService } from './sse-service';
import { Observable } from 'rxjs';
import { notification } from '../models/interfaces/notifications';
import { HttpClient } from '@angular/common/http';
import { TenantService } from '../services/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  apiUri: string;
  graphUri: string;
  private pageNr = 1;
  userName: string;
  componentName: string;
  currentTenantId: number;

  getNotificationsApi = "api/Notification";
  getBatchNotificationUrl = "api/Notification/GetPaginatedNotifications";
  evs: EventSource;

  constructor(private readonly globals: Globals,
    private readonly http: HttpClient,
    private readonly _zone: NgZone,
    private readonly tenantService: TenantService,
    private readonly _sseService: SseService) {
    this.apiUri = this.globals.config.notificationApi_client_resourceUri;
  }

  getTopNotificationList() {
    if (this.globals.userEmail) {
      this.userName = this.globals.userEmail.split("@")[0];
    }
    this.componentName = "Platform Hub";
    let currentTenant = this.tenantService.getCurrentTenant();
    if (currentTenant == undefined) {
      this.currentTenantId = 0;
    }
    else {
      this.currentTenantId = currentTenant.tenantId;
    }

    return new Observable(observer => {
      let url;
      if (this.userName != null) {
        url = this.apiUri + this.getNotificationsApi + "?userName=" + this.userName + "&componentName=" + this.componentName + "&tenantId=" + this.currentTenantId;
      }

      if (this.evs) {
        this.evs.close();
      }

      this.evs = this._sseService.getEventSource(url);
      this.evs.addEventListener('message', event => {
        this._zone.run(() => {
          let returnData = JSON.parse(event.data);
          observer.next(returnData);
        });
      });
    });
  }

  getBatchNotification(): Observable<notification[]> {
    return this.http.get<notification[]>(this.apiUri + this.getBatchNotificationUrl + "?userName=" + this.userName + "&componentName=" + this.componentName + "&pageNo=" + this.pageNr + "&pageSize=10");
  }

  markReadTopNotification(dateString): void {
    this.http.put(this.apiUri + this.getNotificationsApi + "/" + this.userName + "/" + this.componentName + "/" + dateString, null).subscribe();
  }

  setFirstPage(): void {
    this.pageNr = 1;
  }

  paginatePage(): void {
    this.pageNr++;
  }

}
